import { SortOrder } from '@models/table.model.ts';
import { CallStateEnum } from '@models/call-state.model.ts';
import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature.ts';
import { ApiParams, ApiResponse } from '@models/api.model.ts';

export type ApiFunctionType = (
  params?: ApiParams
) => Promise<ApiResponse<any>>;

export type SortTuple = [column: string, order: SortOrder];
export interface TableState extends CallStateMethods {
  search: Record<string, string>;
  filters: Record<string, string[]>;
  between: Record<string, { from: string; to: string }>;
  sort: SortTuple;
  pagination: {
    page: number;
    rowsPerPage: number;
    totalPages: number;
  };
  tableData: any[];
  callState: CallStateEnum;
  apiFunction: ApiFunctionType;
  updateSearch: (columnId: string, value: string) => void;
  updateFilters: (columnId: string, selectedFilters: string[]) => void;
  updateDateRangeFilters: (
    columnId: string,
    selectedFilters: { from: string; to: string }
  ) => void;
  updateSort: (columnId: string, order: SortOrder) => void;
  updatePagination: (newPage: number, newRowsPerPage: number) => void;
  setApiFunctionAndFetchData: (
    apiFunc: ApiFunctionType,
    customParams?: Record<string, any>
  ) => void;

  clearSearch?: (columnId: string) => void;
  clearFilters?: (columnId: string) => void;
  clearDateRangeFilters?: (columnId: string) => void;
  clearSort: () => void;
  clearAllFilters: () => void;
}

interface TableStateMethods extends CallStateMethodNames {
  updateSearch: 'updateSearch';
  updateFilters: 'updateFilters';
  updateSort: 'updateSort';
  updatePagination: 'updatePagination';
  setApiFunctionAndFetchData: 'setApiFunctionAndFetchData';
  updateDateRangeFilters: 'updateDateRangeFilters';
  clearSearch?: 'clearSearch';
  clearFilters?: 'clearFilters';
  clearSort: 'clearSort';
  clearDateRangeFilters?: 'clearDateRangeFilters';
  clearAllFilters?: 'clearAllFilters';
}

export const TABLE_INITIAL_STATE: Omit<TableState, keyof TableStateMethods> = {
  search: {},
  filters: {},
  between: {},
  sort: ['', SortOrder.Ascending],
  pagination: { page: 1, rowsPerPage: 10, totalPages: 1 },
  tableData: [],
  callState: CallStateEnum.Init,
  apiFunction: async () => {
    return {
      rows: [],
      limit: 10,
      page: 1,
      total: 1
    };
  }
};
